export function getErrorHandler(Vue, apm) {
  var _this = this;

  var previousErrorHandler = Vue.config.errorHandler;
  return function (error, vm, info) {
    if (vm && vm.$options) {
      var options = vm.$options;
      var component;

      if (vm.$root === vm) {
        component = 'Root';
      } else {
        component = options.name || options._componentTag || 'Anonymous';
      }

      error.component = component;
      error.file = options.__file || '';
    }

    if (info) {
      error.lifecycleHook = info;
    }

    apm.captureError(error);

    if (typeof previousErrorHandler === 'function') {
      previousErrorHandler.call(_this, error, vm, info);
    }

    console.error(error);
  };
}